<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="!loading">
      <b-form>
        <!-- Campo Nome Completo -->
        <div class="row">
          <div class="col-md-12">
            <b-form-group
              class="mb-3"
              label="Nome Completo"
              invalid-feedback="Digite seu nome completo e sem abreviações"
            >
              <b-form-input
                :disabled="eSocial == 'Qualificado'"
                @input="verificarNome(campo.nomeCompleto)"
                v-model="campo.nomeCompleto"
                type="text"
                :state="validacaoNome"
                autocomplete="off"
                maxlength="60"
                trim
              ></b-form-input>
              <div class="text-center">
                <p
                  v-if="campo.nomeCompleto"
                  class="badge position-absolute"
                  :class="{
                    'bg-success': campo.nomeCompleto.length !== 60,
                    'bg-danger': campo.nomeCompleto.length === 60,
                  }"
                >
                  {{ campo.nomeCompleto.length }} / 60
                </p>
              </div>
            </b-form-group>
          </div>
        </div>

        <!-- Linha com Data de Nascimento, CPF e PIS/INSS -->
        <div class="row">
          <!-- Data de nascimento -->
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Data de nascimento">
              <date-picker
                v-model="campo.DT_NASC"
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY"
                :disabled="eSocial == 'Qualificado'"
                :disabled-date="disabledData()"
                append-to-body
                :editable="false"
                default-panel="year"
                :default-value="dateDefault"
              />
            </b-form-group>
          </div>
          <!-- CPF -->
          <div class="col-md-4">
            <b-form-group class="mb-3" label="CPF">
              <b-form-input
                disabled
                v-mask="'###.###.###-##'"
                v-model="campo.cpf"
                type="text"
              ></b-form-input>
            </b-form-group>
          </div>
          <!-- PIS/INSS com ícone acionador -->
          <div class="col-md-4">
            <div class="form-group">
              <b-form-group class="mb-3" :state="pisValidado">
                <template #label>
                  <div class="d-flex align-items-center">
                    <span>N° PIS/INSS</span>
                    <i
                      class="fas fa-question-circle interrogacao ml-2"
                      id="tooltip-pis"
                      @click="abrirModalPis"
                      style="cursor: pointer; margin-left: 5px;"
                    ></i>
                  </div>
                </template>
                <b-form-input
                  :state="pisValidado"
                  v-model="campo.NR_PIS"
                  v-mask="'###.#####.##-#'"
                  @input="validarPiss(campo.NR_PIS)"
                  :disabled="eSocial == 'Qualificado'"
                  type="text"
                ></b-form-input>
              </b-form-group>
            </div>
          </div>

        </div>

        <!-- Outras informações -->
        <div class="row">
          <div class="col-md-4">
            <b-form-group class="mb-3" label="CNH">
              <multiselect
                v-model="campo.selectCnh"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="name"
                :options="optionTipoCnh"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Registro Profissional">
            <div v-if="disableProfissional">
                <b-form-input
                  trim
                  type="text"
                  :disabled="disableProfissional"
                  v-model="campo.selectRegistroProfissional.name"
                />
              </div>
            <div v-else>
                <multiselect
                  label="name"
                  :allow-empty="false"
                  :show-labels="false"
                  placeholder="Selecione"
                  :disabled="disableProfissional"
                  :options="optionRegistroProfissional"
                  v-model="campo.selectRegistroProfissional"
                >
                  <span slot="noResult">Nenhum resultado encontrado.</span>
                </multiselect>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Estado Civil">
              <multiselect
                v-model="campo.selectEstadoCivil"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="name"
                :options="optionEstadoCivil"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
        </div>

        <!-- Linha com Sexo, Orientação Sexual e Características Físicas -->
        <div class="row">
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Sexo">
              <multiselect
                v-model="campo.selectSexo"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="name"
                :options="optionSexo"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Orientação Sexual">
              <multiselect
                v-model="campo.selectOrientacaoSexual"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="name"
                :options="optionOrientacao"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label="Características Físicas">
              <multiselect
                v-model="campo.selectCaracteristasFisicas"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                label="nm_raca_cor"
                :options="optionCaracFisica"
              >
                <span slot="noResult">Nenhum resultado encontrado.</span>
              </multiselect>
            </b-form-group>
          </div>
        </div>
      </b-form>

      <!-- Botões Salvar e Próximo -->
      <div class="row">
        <div class="mt-1 d-flex justify-content-end">
          <b-button
            variant="success"
            class="d-flex"
            @click="salvarDadosPessoais(true)"
            :disabled="loadingSalvar"
            data-tooltip="Salvar"
            data-tooltip-location="left"
          >
            <i class="mdi mdi-content-save"></i>
            <b-spinner
              class="ms-2"
              small
              variant="primary"
              v-if="loadingSalvar"
            ></b-spinner>
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="mt-3 d-flex justify-content-end">
          <b-button
            variant="primary"
            @click="navegar()"
            data-tooltip="Próximo"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-right-circle font-size-15"></i>
          </b-button>
        </div>
      </div>
    </div>

    <!-- Modal para informações do PIS/INSS -->
    <b-modal
      v-model="showModalPis"
      size="lg"
      title="Informações sobre PIS/INSS"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div class="d-flex justify-content-center">
        <div class="col-md-12 card">
          <div class="card-body">
            <div class="row">
              <h5 class="mt-3 mb-3 font-bold">
                Para gerar o número do PIS/NIS/NIT,
                solicite o cadastramento diretamente em uma agência da Caixa Econômica Federal,
                pelo sistema do empregador via Conectividade Social  ou pelo número 135.
              </h5>
            </div>
            <div class="row">
              <div class="mt-5 d-flex justify-content-end">
                <b-button
                  variant="success"
                  class="mt-1 me-1"
                  @click="fecharModalPis"
                  data-tooltip="Fechar"
                  data-tooltip-location="bottom"
                >
                  Fechar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

export default {
  props: ["dadosPessoaisLoockUp"],
  components: {
    Multiselect,
  },
  data() {
    return {
      dados: {},
      loading: true,
      loadingSalvar: false,
      showModalPis: false,
      campo: {
        nomeCompleto: "",
        nomeVerifica: "",
        DT_NASC: "",
        cpf: "",
        possuiDeficiencia: "",
        NR_PIS: "",
        selectPossuiDeficiencia: {},
        selectCnh: {},
        selectRegistroProfissional: {},
        selectEstadoCivil: {},
        selectSexo: {},
        selectOrientacaoSexual: "",
        selectCaracteristasFisicas: {},
        registroProfissional: {},
      },
      dateDefault: new Date().getFullYear() - 17 + "-01-01",
      campoBK: [],
      verificaCpf: null,
      optionRegistroProfissional: [
        { tp_registro: null, name: "Não possui" },
        { tp_registro: "P", name: "Protocolo" },
        { tp_registro: "R", name: "Registro" },
        { tp_registro: "V", name: "Visto" },
      ],
      optionRegistro: [],
      optionDeficiencia: [
        { value: true, name: "Sim" },
        { value: false, name: "Não" },
      ],
      optionEstadoCivil: [
        { TP_EST_CIVIL: "C", name: "Casado(a)" },
        { TP_EST_CIVIL: "D", name: "Divorciado(a)" },
        { TP_EST_CIVIL: "R", name: "Relação Estável" },
        { TP_EST_CIVIL: "S", name: "Separado(a)" },
        { TP_EST_CIVIL: "T", name: "Solteiro(a)" },
        { TP_EST_CIVIL: "V", name: "Viúvo(a)" },
      ],
      deficienciaDisabled: true,
      optionTipoDeficiencia: [],
      optionCaracFisica: [],
      optionTipoCnh: [
        { TP_CNH: "D", name: "Definitivo" },
        { TP_CNH: "N", name: "Não tem" },
        { TP_CNH: "P", name: "Provisório" },
      ],
      optionSexo: [
        { TP_SEXO: "F", name: "Feminino" },
        { TP_SEXO: "M", name: "Masculino" },
      ],
      optionOrientacao: [
        { tp_orientacao: "E", name: "Heterossexual" },
        { tp_orientacao: "O", name: "Homossexual" },
        { tp_orientacao: "B", name: "Bissexual" },
        { tp_orientacao: "P", name: "Pansexual" },
        { tp_orientacao: "A", name: "Assexual" },
        { tp_orientacao: "U", name: "Outro" },
        { tp_orientacao: "R", name: "Prefiro não informar" },
      ],
      pisValidado: null,
      eSocial: "",
      validacaoNome: null,
      proximo: null,
      customNoResultText: "Nenhum resultado encontrado",
      customNoOptionsText: "Nenhuma opção disponível",
      deficiencias: [],
      cdTipoPessoa: "",
      disableProfissional: false
    };
  },
  async created() {
    await this.fetchUserProfile();
    await this.prepararDadosPessoais();
  },
  methods: {
    async navegar() {
      if (this.validarDadosPessoais() && !this.verificarInputs()) {
        const result = await Swal.fire({
          title: "ATENÇÃO",
          text: "Deseja avançar sem salvar os dados?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Avançar",
          confirmButtonText: "Salvar",
        });
        if (result.isConfirmed) {
          await this.salvarDadosPessoais();
          await this.deletarPCDs(true);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.close();
        }
        this.$emit("navegar", "redesSociais", true);
      } else if (this.validarDadosPessoais() && this.verificarInputs()) {
        this.$emit("navegar", "PCD", true);
      }
    },
    verificarInputs() {
      if (this.campoBK.nomeCompleto != this.campo.nomeCompleto) return false;
      if (this.campoBK.DT_NASC != this.campo.DT_NASC) return false;
      if (
        this.campoBK.NR_PIS.replace(/\W/g, "") !=
        this.campo.NR_PIS.replace(/\W/g, "")
      )
        return false;
      if (this.campoBK.selectCnh != this.campo.selectCnh) return false;
      if (
        this.campoBK.selectRegistroProfissional !=
        this.campo.selectRegistroProfissional
      )
        return false;
      if (this.campoBK.selectEstadoCivil != this.campo.selectEstadoCivil)
        return false;
      if (this.campoBK.selectSexo != this.campo.selectSexo) return false;
      if (
        this.campoBK.selectOrientacaoSexual != this.campo.selectOrientacaoSexual
      )
        return false;
      if (
        this.campoBK.selectCaracteristasFisicas !=
        this.campo.selectCaracteristasFisicas
      )
        return false;
      if (
        this.campoBK.possuiDeficiencia.value !=
        this.campo.possuiDeficiencia.value
      )
        return false;
      return true;
    },
    deletarPCDs() {
      if (
        this.campo.possuiDeficiencia.value == false &&
        this.deficiencias.length > 0
      ) {
        this.$http
          .post("api/cadastroCandidato/deletarDeficienciaByPessoa")
          .then(() => {
            this.$tools.alerta("Deficiências excluídas com sucesso", "success");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    async carregarAbaPCD() {
      if (this.campo.possuiDeficiencia.value == false) {
        this.$emit("ativarPCD", false);
      } else {
        this.$emit("ativarPCD", true);
      }
    },
    async prepararDadosPessoais() {
      try {
        const isErp = this.$store.state.user?.tipoUsuario === 'erp' || this.$store.state.me?.user_erp;
        const endpointMe = isErp ? "api/authErp/meErp" : "api/auth/me";
        
        const respMe = await this.$http.get(endpointMe);
        const enviaParaIndex = { authMe: respMe.data };
        this.cdTipoPessoa = respMe.data.tp_Pessoa.cd_tp_pessoa;
        if (this.cdTipoPessoa == 5) {
          const response = await this.$http.get(
            "api/cadastroCandidato/buscarInfoCandidato"
          );
          this.eSocial = response.data[0].STQUALIFICACAO;
          enviaParaIndex.infoCandidato = response.data[0];
        } else if (this.cdTipoPessoa == 1) {
          const response = await this.$http.get(
            "api/cadastroCandidato/buscarInfoPrincipal"
          );
          this.eSocial = response.data[0].STQUALIFICACAO;
          enviaParaIndex.infoCandidato = response.data[0];
        }
        const [
          respRacaCor,
          respDadosPessoais,
          respProfissional,
          respDeficiencia
        ] = await Promise.all([
          this.$http.get("api/cadastroCandidato/buscarRacaCor"),
          this.$http.get("api/cadastroCandidato/buscarDadosPessoais"),
          this.$http.get("api/cadastroCandidato/buscarRegistroProfissional"),
          this.$http.get("api/cadastroCandidato/buscarDeficiencia"),
          this.$http.get(endpointMe),
        ]);
        this.optionCaracFisica = respRacaCor.data.map((item) => ({
          ...item,
          nm_raca_cor:
            item.nm_raca_cor.charAt(0).toUpperCase() +
            item.nm_raca_cor.slice(1).toLowerCase(),
        }));
        this.dados = respDadosPessoais.data[0];
        enviaParaIndex.registroProfissional = respProfissional.data[0];
        enviaParaIndex.dadosPessoais = respDadosPessoais.data[0];
        this.deficiencias = respDeficiencia.data;
        if (this.deficiencias.length > 0) {
          this.campo.possuiDeficiencia = { value: true, name: "Sim" };
          this.carregarAbaPCD();
        } else {
          this.campo.possuiDeficiencia = { value: false, name: "Não" };
        }
        this.$emit("recebeDadosPessoais", enviaParaIndex);
        this.preencheCamposDaTela(respMe.data, respProfissional.data);
      } catch (err) {
        this.$tools.alerta(err, "error");
      }
    },
    preencheCamposDaTela(responseMe, responseProfissional) {
      this.campo.NR_PIS = this.dados.NR_PIS
        ? this.dados.NR_PIS.padStart(11, "0")
        : null;
      this.campo.cpf = responseMe.nr_docto
        ? responseMe.nr_docto.padStart(11, "0")
        : null;
      this.campo.DT_NASC = this.dados.DT_NASC ? this.dados.DT_NASC : null;
      this.campo.selectCnh = this.optionTipoCnh.find(
        (el) => el.TP_CNH == this.dados.TP_CNH
      );
      this.campo.selectSexo = this.optionSexo.find(
        (el) => el.TP_SEXO == this.dados.TP_SEXO
      );
      this.campo.selectOrientacaoSexual = this.optionOrientacao.find(
        (el) => el.tp_orientacao == this.dados.TP_ORIENTACAO_SEXO
      );
      this.campo.selectEstadoCivil = this.optionEstadoCivil.find(
        (el) => el.TP_EST_CIVIL == this.dados.TP_EST_CIVIL
      );
      this.campo.selectCaracteristasFisicas = this.optionCaracFisica.find(
        (el) => el.sq_raca_cor == this.dados.SQ_RACA_COR
      );

      const profissionalPrincipal = responseProfissional.find(
        (itm) => itm.PRINCIPAL === "Sim"
      );
      if (profissionalPrincipal) {
        this.campo.registroProfissional = profissionalPrincipal;
        this.campo.selectRegistroProfissional = this.optionRegistroProfissional.find(
          (itm) => itm.tp_registro === profissionalPrincipal.TPREGISTRO
        ) || null;
      } else {
        this.campo.registroProfissional = null;
        this.campo.selectRegistroProfissional = null;
      }
      this.campo.nomeCompleto = responseMe.nm_razao;
      this.campo.nomeVerifica = responseMe.nm_razao;
      this.campo.registroProfissional = responseProfissional
        ? responseProfissional
        : null;
      this.campoBK = Object.assign({}, this.campo);
      this.loading = false;
    },
    validarDadosPessoais() {
      if (
        !this.campo.nomeCompleto ||
        !this.campo.DT_NASC ||
        !this.campo.NR_PIS ||
        !this.campo.selectCnh ||
        !this.campo.selectRegistroProfissional ||
        !this.campo.selectEstadoCivil ||
        !this.campo.selectSexo ||
        !this.campo.selectOrientacaoSexual ||
        !this.campo.selectCaracteristasFisicas
      ) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        return false;
      }
      if (!this.pisValidado) {
        this.$tools.alerta("Verifique se o Nº do PIS está válido", "warning");
        return false;
      }
      return true;
    },
    async salvarDadosPessoais(valida = false) {
      if (valida) {
        if (!this.validarDadosPessoais()) {
          return;
        }
      }
      var item = {};
      var itemProf = {};
      var nome = {};
      if (
        this.deficiencias.length > 0 &&
        this.campo.possuiDeficiencia.value == false
      ) {
        try {
          await this.$tools.alertaConfirm(
            "Esta ação irá excluir todas as deficiências cadastradas. Deseja continuar?"
          );
          await this.deletarPCDs();
        } catch {
          return false;
        }
      }
      if (this.campo.nomeCompleto != this.campoBK.nomeCompleto) {
        nome.nome = this.campo.nomeCompleto;
        this.$http.post("api/cadastroCandidato/updateNome", nome);
      }
      item.piss = this.campo.NR_PIS.replace(/[^\d]+/g, "");
      item.nasc = this.campo.DT_NASC;
      item.cnh = this.campo.selectCnh.TP_CNH;
      item.estadoCivil = this.campo.selectEstadoCivil.TP_EST_CIVIL;
      item.sexo = this.campo.selectSexo.TP_SEXO;
      item.orientacao = this.campo.selectOrientacaoSexual.tp_orientacao;
      item.CaracFisicas = this.campo.selectCaracteristasFisicas.sq_raca_cor;
      itemProf.tpRegistro = this.campo.selectRegistroProfissional.tp_registro;
      this.loadingSalvar = true;
      await Promise.all([
        this.$http.post("api/cadastroCandidato/insertDadosPessoais", item),
        this.$http.post("api/cadastroCandidato/insereTpRegistro", itemProf),
      ])
        .then(() => {
          Swal.fire({
            title: "<strong>Dados cadastrados com sucesso</strong>",
            icon: "success",
            timer: 5000,
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
            position: "top-end",
          });
          this.$emit("carregarNivelPerfil");
          this.campoBK = Object.assign({}, this.campo);
        })
        .catch(() => {
          this.$tools.alerta("Erro ao cadastrar os dados pessoais", "error");
        });
      this.loadingSalvar = false;
    },
    validarPiss(pis) {
      pis = pis.replace(/\D/g, "");
      if (pis.length !== 11) {
        this.pisValidado = false;
        return;
      }
      if (/^(\d)\1+$/.test(pis)) {
        this.pisValidado = false;
        return;
      }
      var total = 0;
      var peso = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      var resto;
      var dv = pis.substring(10, 11);
      for (var i = 0; i < 10; i++) {
        total += pis.charAt(i) * peso[i];
      }
      resto = 11 - (total % 11);
      if (resto === 10 || resto === 11) {
        resto = 0;
      }
      if (resto !== parseInt(dv)) {
        this.pisValidado = false;
        return;
      }
      this.pisValidado = true;
      return;
    },
    disabledData() {
      const dataAtual = new Date();
      dataAtual.setFullYear(dataAtual.getFullYear() - 18);
      return (date) => date >= dataAtual;
    },
    verificarNome(nome) {
      this.campo.nomeCompleto = nome.toUpperCase();
      if (/^(?=.*\s)[\p{L}\s]{0,60}$/u.test(nome)) {
        this.validacaoNome = true;
        return;
      } else {
        this.validacaoNome = false;
        return;
      }
    },
    // Métodos para controle do modal do PIS/INSS
    abrirModalPis() {
      this.showModalPis = true;
    },
    fecharModalPis() {
      this.showModalPis = false;
    },

    async fetchUserProfile() {
      const response = await this.$http.get('api/cadastroCandidato/buscarProfileCadastro');
      const userProfileExists = response.data !== 1;
      this.disableProfissional = userProfileExists;
    }
  },
};
</script>
